<template>
  <div>
    <BorderTitle> {{ item.title }}</BorderTitle>
    <div class="margin10"></div>
    <div v-html="item.content"></div>
    <div class="margin10"></div>
    <BorderTitle>适用范围</BorderTitle>
    <div class="margin10"></div>
    <DiseaseTag type="wx" :list="tagList"></DiseaseTag>
  </div>
</template>

<script>
import BorderTitle from "./title.vue";
export default {
  components: {
    BorderTitle,
  },
  props: {
    item: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    tagList() {
      return this.item.areaApplication.split(",");
    },
  },
};
</script>

<style>
</style>